import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu-audit",
  "use": "icon-menu-audit-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-menu-audit\">\r\n<path d=\"M189.7,16.3c-3-0.7-61-11.2-89.7-16.3C71.4,5.1,13.4,15.6,10.3,16.3C5,17.6,0,24.7,0,28.9v92.4c0,2.9,1.4,36.8,100,78.8\r\n\tc98.6-42,100-75.8,100-78.8V28.9C200,24.7,195,17.6,189.7,16.3z M147,130.3C147,130.3,147,130.3,147,130.3c0,1.2-1,2.2-2.2,2.1H55.2\r\n\tc-1.2,0-2.2-1-2.2-2.1v-19.9c0-3.7,3.1-6.7,7-6.7h17.6c4.7,0,8.6-3.4,9-7.9c0.5-5.9-2.5-10.3-5.7-15c-3.4-4.9-6.9-10.1-6.9-17.7\r\n\tc0-12.6,10-22.7,26.1-22.7c16.1,0,26.1,10.2,26.1,22.8c0,7.6-3.6,12.8-6.9,17.7c-3.2,4.7-6.2,9.1-5.7,15c0.4,4.5,4.3,7.9,9,7.9h17.6\r\n\tc3.8,0,7,3,7,6.7V130.3z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/menu/menu-audit.svg
// module id = DM6P
// module chunks = 13